<script lang="ts">
	export let imageSrc: string;
	export let tooltipText: string;
	export let imageWidth: number | string = 'auto';
	export let imageHeight: number | string = 'auto';
	export let showTooltip = true;
	export let disabled = false;
	export let isActive = false;
	export let onClick: (() => void) | undefined = undefined;
	export let showHoverFeedback = false;
</script>

<div class="tooltip-wrapper">
	<button
		on:click={onClick}
		type="button"
		{disabled}
		class:active={isActive}
		class:circular-hover={showHoverFeedback}>
		<img src={imageSrc} alt={tooltipText} width={imageWidth} height={imageHeight} />
	</button>
	{#if showTooltip}
		<div class="tooltip">{tooltipText}</div>
	{/if}
</div>

<style>
	button {
		padding: 0;
		transition: filter 0.2s;
		border: none;
		border-radius: 4px;
		background: transparent;
		cursor: pointer;
	}

	button:disabled {
		opacity: 0.5;
		cursor: default;
	}

	button:hover:not(:disabled) {
		filter: brightness(0.8);
	}

	button:active:not(:disabled) {
		filter: brightness(0.6);
	}

	button.active:not(:disabled) {
		filter: brightness(0.8);
	}

	button.circular-hover {
		display: flex;
		position: relative;
		align-items: center;
		justify-content: center;
		block-size: 4rem;
		inline-size: 4rem;
		padding: 0;
		transition: background-color 0.2s ease, filter 0.2s ease;
		border-radius: 50%;
	}

	button.circular-hover:hover:not(:disabled) {
		background-color: rgb(0 0 0 / 10%);
		filter: none;
	}

	button.circular-hover:active:not(:disabled) {
		background-color: rgb(0 0 0 / 20%);
		filter: none;
	}

	button.circular-hover.active:not(:disabled) {
		background-color: rgb(0 0 0 / 15%);
		filter: none;
	}

	.tooltip-wrapper {
		position: relative;
	}

	.tooltip {
		visibility: hidden;
		position: absolute;
		margin-block-end: 1.5rem;
		padding-block: 0.8rem;
		padding-inline: 1.5rem;
		transform: translateX(-50%);
		transition: opacity 0.2s;
		border-radius: 4px;
		opacity: 0;
		background: #1d354b;
		color: white;
		font-size: 14px;
		font-weight: bold;
		white-space: nowrap;
		inset-block-end: 100%;
		inset-inline-start: 50%;
	}

	.tooltip::after {
		content: '';
		position: absolute;
		inset-block-start: 100%;
		inset-inline-start: 50%;
		transform: translateX(-50%);
		border: 6px solid transparent;
		border-block-start-color: #1d354b;
	}

	.tooltip-wrapper:hover .tooltip {
		visibility: visible;
		opacity: 1;
	}

	img {
		pointer-events: none;
	}
</style>
